"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorQuerySourceIdentifyCompositeFile = void 0;
const actor_query_source_identify_rdfjs_1 = require("@comunica/actor-query-source-identify-rdfjs");
const bus_query_source_identify_1 = require("@comunica/bus-query-source-identify");
const context_entries_1 = require("@comunica/context-entries");
const core_1 = require("@comunica/core");
const utils_algebra_1 = require("@comunica/utils-algebra");
const utils_bindings_factory_1 = require("@comunica/utils-bindings-factory");
const rdf_stores_1 = require("rdf-stores");
/**
 * A comunica Composite File Query Source Identify Actor.
 */
class ActorQuerySourceIdentifyCompositeFile extends bus_query_source_identify_1.ActorQuerySourceIdentify {
    mediatorQuerySourceIdentify;
    mediatorMergeBindingsContext;
    constructor(args) {
        super(args);
        this.mediatorQuerySourceIdentify = args.mediatorQuerySourceIdentify;
        this.mediatorMergeBindingsContext = args.mediatorMergeBindingsContext;
    }
    async test(action) {
        if (action.querySourceUnidentified.type !== 'compositefile') {
            return (0, core_1.failTest)(`${this.name} requires a single query source with compositefile type to be present in the context.`);
        }
        if (!Array.isArray(action.querySourceUnidentified.value)) {
            return (0, core_1.failTest)(`${this.name} requires a compositefile source with an array of file URLs as value.`);
        }
        return (0, core_1.passTestVoid)();
    }
    async run(action) {
        const compositeSource = action.querySourceUnidentified;
        const dataFactory = action.context.getSafe(context_entries_1.KeysInitQuery.dataFactory);
        const AF = new utils_algebra_1.AlgebraFactory(dataFactory);
        // Create a combined RDF store from all file sources
        const store = rdf_stores_1.RdfStore.createDefault(true);
        for (const source of compositeSource.value) {
            // TODO: if we would run into performance issues due to this temporary index+query step,
            //  use a transient query-once index.
            const querySource = typeof source === 'string' ?
                (await this.mediatorQuerySourceIdentify.mediate({
                    querySourceUnidentified: { type: 'file', value: source },
                    context: action.context,
                })).querySource :
                source;
            // Get all quads from this source using a wildcard quad pattern
            const sourceQuadStream = querySource.source.queryQuads(AF.createPattern(dataFactory.variable('s'), dataFactory.variable('p'), dataFactory.variable('o'), dataFactory.variable('g')), action.context);
            // Import quads into the combined store
            await new Promise((resolve, reject) => {
                store.import(sourceQuadStream)
                    .on('error', reject)
                    .once('end', resolve);
            });
        }
        const querySource = new actor_query_source_identify_rdfjs_1.QuerySourceRdfJs(store, dataFactory, await utils_bindings_factory_1.BindingsFactory.create(this.mediatorMergeBindingsContext, action.context, dataFactory));
        const sourceValues = compositeSource.value
            .map(source => typeof source === 'string' ? source : source.source.referenceValue);
        querySource.referenceValue = sourceValues.join('\n');
        querySource.toString = () => `QuerySourceRdfJs(composite: ${sourceValues.join(',')})`;
        return {
            querySource: {
                source: querySource,
                context: compositeSource.context,
            },
        };
    }
}
exports.ActorQuerySourceIdentifyCompositeFile = ActorQuerySourceIdentifyCompositeFile;
//# sourceMappingURL=ActorQuerySourceIdentifyCompositeFile.js.map